import React from 'react';
import { ArrowLeft, MapPin, Phone, Mail } from 'lucide-react';
import { Link } from 'react-router-dom';

const Impresszum = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-12">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Back Button */}
        <Link 
          to="/" 
          className="inline-flex items-center text-[#00BCD4] hover:text-[#FFA726] mb-6 transition-colors"
        >
          <ArrowLeft className="w-5 h-5 mr-2" />
          Vissza a főoldalra
        </Link>

        {/* Header */}
        <div className="bg-white rounded-lg shadow-sm p-8 mb-6">
          <h1 className="text-4xl font-bold mb-2">
            <span className="text-[#00BCD4]">Impresszum</span>
          </h1>
          <p className="text-gray-600">Jogi és kapcsolattartási információk</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-sm p-8">
          <div className="space-y-8">
            {/* Szolgáltató adatai */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b-2 border-[#00BCD4] pb-2">
                Szolgáltató adatai
              </h2>
              <div className="space-y-3">
                <div>
                  <p className="text-sm text-gray-500 mb-1">Szolgáltató neve</p>
                  <p className="text-lg font-semibold text-gray-800">Horváth Attila EV</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Székhely</p>
                  <p className="text-gray-800">2315 Szigethalom, Széchenyi u. 44</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500 mb-1">Adószám</p>
                  <p className="text-gray-800">56589119-1-33</p>
                </div>
              </div>
            </section>

            {/* Elérhetőségek */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b-2 border-[#00BCD4] pb-2">
                Elérhetőségek
              </h2>
              <div className="space-y-4">
                <div className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-[#00BCD4] flex-shrink-0 mt-1" />
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Email</p>
                    <a 
                      href="mailto:maszek.ah37@gmail.com"
                      className="text-gray-800 hover:text-[#00BCD4] transition-colors"
                    >
                      maszek.ah37@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Phone className="w-5 h-5 text-[#00BCD4] flex-shrink-0 mt-1" />
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Telefonszám</p>
                    <a 
                      href="tel:+36309517159"
                      className="text-gray-800 hover:text-[#00BCD4] transition-colors"
                    >
                      +36 30 951 7159
                    </a>
                  </div>
                </div>

                <div className="flex items-start space-x-3">
                  <Mail className="w-5 h-5 text-[#00BCD4] flex-shrink-0 mt-1" />
                  <div>
                    <p className="text-sm text-gray-500 mb-1">Panaszkezelési email</p>
                    <a 
                      href="mailto:rendeles@boldogbufe.hu"
                      className="text-gray-800 hover:text-[#00BCD4] transition-colors"
                    >
                      rendeles@boldogbufe.hu
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* Tárhely és technikai szolgáltatás */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b-2 border-[#00BCD4] pb-2">
                Tárhely és technikai szolgáltatás
              </h2>
              <p className="text-gray-700">
                <strong>Tárhely szolgáltató:</strong> Saját szerver
              </p>
              <p className="text-sm text-gray-600 mt-2">
                A weboldal technikai üzemeltetése és tárhelye saját infrastruktúrán fut.
              </p>
            </section>

            {/* Tevékenységi kör */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b-2 border-[#00BCD4] pb-2">
                Tevékenységi kör
              </h2>
              <p className="text-gray-700 mb-4">
                Vendéglátás, éttermi szolgáltatás, elviteles étkezés, házhozszállítás.
              </p>
              <div>
                <p className="text-sm text-gray-500 mb-2">Kiszállítási területek:</p>
                <div className="flex flex-wrap gap-2">
                  <span className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">Szigethalom</span>
                  <span className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">Halásztelek</span>
                  <span className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">Tököl</span>
                  <span className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">Szigetszentmiklós</span>
                  <span className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">Dunaharaszti</span>
                  <span className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">Dunavarsány</span>
                  <span className="px-3 py-1 bg-gray-100 rounded-full text-sm text-gray-700">Taksony</span>
                </div>
              </div>
            </section>

            {/* Jogi dokumentumok */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b-2 border-[#00BCD4] pb-2">
                Jogi dokumentumok
              </h2>
              <div className="space-y-2">
                <Link 
                  to="/aszf" 
                  className="block text-[#00BCD4] hover:text-[#FFA726] transition-colors"
                >
                  → Általános Szerződési Feltételek (ÁSZF)
                </Link>
                <Link 
                  to="/adatvedelem" 
                  className="block text-[#00BCD4] hover:text-[#FFA726] transition-colors"
                >
                  → Adatvédelmi Tájékoztató
                </Link>
              </div>
            </section>

            {/* Felelősség korlátozása */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b-2 border-[#00BCD4] pb-2">
                Felelősség korlátozása
              </h2>
              <p className="text-gray-700">
                A weboldalon található információk tájékoztató jellegűek. 
                A szolgáltató fenntartja a jogot az árak, nyitvatartási idők és 
                egyéb információk előzetes értesítés nélküli módosítására. 
                Az esetleges téves adatokért felelősséget nem vállalunk.
              </p>
            </section>

            {/* Vitarendezés */}
            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4 border-b-2 border-[#00BCD4] pb-2">
                Vitarendezés
              </h2>
              <p className="text-gray-700 mb-4">
                Fogyasztói jogvita esetén az alábbi hatóságokhoz fordulhat:
              </p>
              <div className="space-y-4 text-gray-700">
                <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
                  <p className="font-semibold mb-2">Pest Megyei Békéltető Testület</p>
                  <p className="text-sm">Cím: 1055 Budapest, Kossuth Lajos tér 6-8.</p>
                  <p className="text-sm">Email: pmbekelteto@pmkik.hu</p>
                  <p className="text-sm">Weboldal: www.bekeltetes.hu</p>
                </div>
                <div className="bg-blue-50 border-l-4 border-blue-400 p-4">
                  <p className="font-semibold mb-2">Online vitarendezési platform (ODR)</p>
                  <p className="text-sm">
                    <a 
                      href="https://ec.europa.eu/consumers/odr" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#00BCD4] hover:underline"
                    >
                      https://ec.europa.eu/consumers/odr
                    </a>
                  </p>
                </div>
              </div>
            </section>
          </div>

          {/* Footer */}
          <div className="mt-12 pt-8 border-t text-center text-sm text-gray-500">
            <p>
              &copy; {new Date().getFullYear()} Horváth Attila EV. Minden jog fenntartva.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impresszum;
